import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

export const routes: RouteObject[] = [{ path: '/settings/backups', element: <Navigate to="/admin/settings" replace /> }]
